function cov_rkb62rso3() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Close16.tsx";
  var hash = "a323f52c1aef9a5062973d317fc7a0b967804b6d";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Close16.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 48
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "a323f52c1aef9a5062973d317fc7a0b967804b6d"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_rkb62rso3 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_rkb62rso3();
var Icon = (cov_rkb62rso3().s[0]++, {
  name: 'close-16',
  svg: "<path d=\"M10.6515 12.4191C11.1397 12.9072 11.9312 12.9072 12.4193 12.4191C12.9075 11.9309 12.9075 11.1395 12.4193 10.6513L9.76804 8.00003L12.4193 5.34875C12.9075 4.86059 12.9075 4.06914 12.4193 3.58098C11.9312 3.09283 11.1397 3.09283 10.6515 3.58098L8.00027 6.23226L5.34824 3.58023C4.86008 3.09207 4.06863 3.09207 3.58047 3.58023C3.09232 4.06838 3.09232 4.85984 3.58047 5.34799L6.2325 8.00002L3.58048 10.652C3.09232 11.1402 3.09232 11.9317 3.58048 12.4198C4.06863 12.908 4.86009 12.908 5.34824 12.4198L8.00027 9.76779L10.6515 12.4191Z\" fill=\"currentColor\"/>"
});
export default Icon;